<template>
  <div class="main">
    <div class="header ub-box ub-row">
      <div class="left">
        <img src="../../assets/img/hospital.png" />
      </div>
      <div class="right ub-flex-1 ub-box ub-col">
        <div class="hospital-info ub-box ub-row">
          <div class="hospital-info-right">
            <div class="hospital-name">{{ redetailInfo.hospitalName }}</div>
            <div class="relevel-name">{{ redetailInfo.regLevelName }}</div>
          </div>
          <div class="status">
            <div
              v-if="!redetailInfo.seeFlag && $route.query.validFlag === '1'"
              style="color: #ff976a"
            >
              未看诊
            </div>
            <div
              v-if="redetailInfo.seeFlag && $route.query.validFlag === '1'"
              style="color: #07c160"
            >
              已看诊
            </div>
            <div v-if="$route.query.validFlag === '0'" style="color: #999">
              已退费
            </div>
            <div v-if="$route.query.validFlag === '2'" style="color: #999">
              已失效
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border ub-box ub-col">
      <div class="item ub-box ub-ver-v ub-between">
        <div>就诊卡号</div>
        <div>{{ redetailInfo.medCardNo }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>就诊流水号</div>
        <div>{{ redetailInfo.clinicId }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>院区名称</div>
        <div>{{ redetailInfo.branchName }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>科室名称</div>
        <div>{{ redetailInfo.regDeptName }}</div>
      </div>
      <div
        class="item ub-box ub-ver-v ub-between"
        v-if="redetailInfo.regDocName"
      >
        <div>医生名称</div>
        <div>{{ redetailInfo.regDocName }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>患者姓名</div>
        <div>{{ redetailInfo.clientName }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>挂号时间</div>
        <div>{{ redetailInfo.regDate }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>就诊序号</div>
        <div>{{ $route.query.seeNo }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>发票号</div>
        <div>{{ $route.query.invoiceNo }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>费用</div>
        <div class="money">￥ {{ $route.query.regFee }}</div>
      </div>
    </div>
    <div class="popup"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      radio: "",
      redetailInfo: {},
      isDiffNoonhospital: true,
    };
  },
  async mounted() {
    this.getredetailInfo();
  },
  methods: {
    //判断是否是今天，选择是否是挂号状态
    isToday(str) {
      let time = new Date();
      return (
        `${time.getFullYear()}-${
          (time.getMonth() + 1).length === 2
            ? time.getMonth() + 1
            : "0" + (time.getMonth() + 1)
        }-${time.getDate()}` === (str ? str.substr(0, 10) : "")
      );
    },
    //退费点击处理函数
    handleClick(clientName, medCardNo, regFee, invoiceNo) {},
    //获取挂号详情表信息
    async getredetailInfo() {
      try {
        this.$showLoad();
        let ret = await this.$axios.get(
          "/register/getregisterbyid?clinicId=" + this.$route.query.clinicId
        );
        this.redetailInfo = { ...ret.data };
        console.log(this.redetailInfo);
        this.$hideLoad();
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取挂号详情信息失败, 请重试");
      }
    },
    //根据患者就诊编号获取门诊缴费记录
  },
};
</script>
<style lang="scss" scope>
.main {
  .header {
    width: 100%;
    padding: 20px;
    background-color: #f5f6fa;
    .left {
      margin-top: 5px;
      img {
        height: 50px;
        width: 50px;
        border-radius: 100px;
      }
    }
    .right {
      margin-left: 15px;
      .hospital-info {
        justify-content: space-between;
        .hospital-info-right {
          .hospital-name {
            font-size: 18px;
            color: #576574;
          }
          .relevel-name {
            margin-top: 5px;
            font-size: 16px;
            color: #a5b1c2;
          }
        }
        .status {
          color: #20bf6b;
          font-size: 16px;
          margin-top: 5px;
        }
      }
      .visit-time {
        margin-top: 16px;
        font-size: 14px;
        color: #4b6584;
      }
    }
  }
  .border {
    margin-top: 10px;
    .item {
      font-size: 16px;
      color: #0a3d62;
      padding: 20px 0;
      margin: 0 20px;
      line-height: 20px;
      border-bottom: 1px solid #f1f1f1;
      .money {
        color: #eb3b5a;
        font-weight: bold;
        font-size: 20px;
      }
    }
  }
  .footer {
    margin: 60px 0 40px;
    padding: 0 55px;
  }
  .popup {
    .van-popup {
      padding: 5px 10px;
      .van-cell__title {
        font-size: 16px;
        color: #0a3d62;
      }
    }
    .cancel-confirm {
      padding: 5px 6px 15px 10px;
      font-size: 17px;
      overflow: hidden;
      .cancel {
        color: #ea8685;
      }
      .confirm {
        color: #2d98da;
      }
    }
  }
}
</style>